import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { emptyArray } from 'constants/emptyConst';
import { Autocomplete, TextField, Typography } from '@totalsoft/rocket-ui';

const AddVerificationsComponent = ({
  addedVerifications,
  handleVerificationsChange,
  handleVerificationEntityChange,
  verificationEntity,
  documentEntities,
  canAddVerifications,
  verificationTypes
}) => {
  const [t] = useTranslation();

  const filterOfferEntities = () => {
    if (documentEntities && !!documentEntities.length) {
      let result = [...emptyArray];
      documentEntities.forEach(oe => (result = result.concat(...oe.list)));
      return result;
    }

    return emptyArray;
  };

  const onVerificationsChange = value => {
    handleVerificationsChange(value);
  };

  const onEntityChange = value => {
    handleVerificationEntityChange(value);
  };

  return (
    <Grid item xs={12}>
      <Typography variant='h6'>{t('OfferEdit.Client.Verification.AddNewCheck')}</Typography>
      <br />
      <Grid container spacing={2}>
        <Grid item container xs={6} direction={'column'}>
          <Grid item xs={12}>
            <Autocomplete
              id='offerPartnerVerification_partnerManualInterrogationModal_entityList'
              options={filterOfferEntities()}
              value={verificationEntity}
              getOptionLabel={option => (Object.keys(option).length > 0 ? option.name : '')}
              onChange={value => onEntityChange(value)}
              openOnFocus
              size='small'
              renderInput={params => <TextField {...params} variant='outlined' label={t('OfferEdit.Client.Verification.Entity')} />}
            />
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            id='offerPartnerVerification_partnerManualInterrogationModal_verificationList'
            isMultiSelection
            renderTags={() => null}
            filterSelectedOptions
            disabled={!canAddVerifications()}
            value={addedVerifications}
            valueKey='verificationTypeId'
            labelKey='verificationName'
            options={verificationTypes}
            onChange={value => onVerificationsChange(value)}
            renderInput={params => <TextField {...params} placeholder={t('OfferEdit.Client.Verification.SelectVerifications')} />}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

AddVerificationsComponent.propTypes = {
  documentEntities: PropTypes.array.isRequired,
  verificationTypes: PropTypes.array.isRequired,
  handleVerificationsChange: PropTypes.func.isRequired,
  handleVerificationEntityChange: PropTypes.func.isRequired,
  canAddVerifications: PropTypes.func.isRequired,
  verificationEntity: PropTypes.object,
  addedVerifications: PropTypes.array
};

export default AddVerificationsComponent;
